<template>
  <div>
    <el-dialog
      title="装卸队动账调整"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          class="demo-cityForm"
          label-width="170px"
          ref="refCityForm"
          v-loading="dialogLoading"
          :model="cityForm"
          :rules="cityRules"
        >
          <el-form-item label="选择装卸队" prop="fleet_id">
            <el-select
              v-model="cityForm.fleet_id"
              clearable
              placeholder="选择装卸队"
            >
              <el-option
                v-for="item in Filterdata2"
                :key="item.id"
                :label="item.fleetName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="flow_type">
            <el-select
              v-model="cityForm.flow_type"
              clearable
              @change="typechange"
              placeholder="请选择类型"
            >
              <el-option
                v-for="item in Filterdata1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调整金额" prop="amount">
            <el-input
              v-model="cityForm.amount"
              placeholder="请输入差异调整金额"
              clearable
            ></el-input>
            <div
              style="color: red"
              v-if="cityForm.flow_type == 21 || cityForm.flow_type == 22"
            >
              请输入正整数，审核通过后将从装卸队扣除该金额
            </div>
          </el-form-item>
          <el-form-item label="转账时间" prop="transfer_time">
            <el-date-picker
              type="datetime"
              v-model="cityForm.transfer_time"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="转账时间"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="转帐记录" prop="transfer_img" >
            <el-upload
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :class="{ hide: transfer_img.length == 1 }"
              :file-list="transfer_img"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'transfer_img');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'transfer_img');
                }
              "
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
  

          <el-form-item label="客户备注" prop="remark">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="cityForm.remark"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="onHandleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "addLautdDialog",
  props: {},
  data() {
    return {
      transfer_img: [],
      dialogVisible: false,
      dialogLoading: false,
      Filterdata1: [],
      Filterdata2: [],
      // 城市仓参数
      cityForm: {
        fleet_id: "", //	T文本	是	装卸队
        amount: "", //	T文本	是	金额
        flow_type: "", //	T文本	是	流水类型: 10-装卸收入，11-用板收入，12-合车收入，13-动帐差异调整收入，14-售后回款，20售后支出，21-动帐差异调整支出，22-打款
        transfer_time: "", //	T文本	是	转账时间
        transfer_img: "", //	T文本	是	转账凭证
        remark: "", //	T文本	是	备注
      },

      submitLoading: false, // 提交按钮禁用

      // 表单校验
      cityRules: {
    
      },


Rules1:{
  fleet_id: [
          {
            required: true,
            message: "请选择装卸队",
            trigger: ["blur", "change"],
          },
        ],
        flow_type: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入差异调整金额",
            trigger: ["blur", "change"],
          },
        ],
        transfer_time: [
          {
            required: true,
            message: "请选择转账时间",
            trigger: ["blur", "change"],
          },
        ],
       
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: ["blur", "change"],
          },
        ],
},
Rules2:{
   transfer_img: [
          {
            required: true,
            message: "请上传转帐记录",
            trigger: ["blur", "change"],
          },
        ],
},



          
    };
  },
  created(){
this.cityRules={
  ...this.Rules1
}
  },
  methods: {
    typechange(){
if(this.cityForm.flow_type == 14 || this.cityForm.flow_type == 22){
this.cityRules={
  ...this.Rules1,
  ...this.Rules2,
}
}else{
  this.cityRules={
  ...this.Rules1
}
}
this.$refs.refCityForm?.clearValidate();
    },
    handlePictureCardPreview(file) {
      console.log("object", file);
      //   this.bigImage = file.url;
      //   this.dialogImage = true;
    },
    uploadFile(options, name) {
      // 拿到 file
      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      var event = event || window.event;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.uploadImage(e.target.result, name);
      };
    },
    uploadImage(img, name) {
      this.$api.general.uploadImage({ file_data: img }).then((res) => {
        this.transfer_img.push({ url: res.data });
        this.cityForm.transfer_img = this.transfer_img
          .map((el) => el.url)
          .join(",");
      });
    },
    deleteFile(file, fileList, name) {
      this.transfer_img = fileList;
      this.cityForm.transfer_img = this.transfer_img
        .map((el) => el.url)
        .join(",");
    },
    getfleetlist() {
      this.$api.fz
        .fleetlist({
          type: 1,
        })
        .then((res) => {
          this.Filterdata2 = res.data;
        });
    },
    getflowtype() {
      this.$api.fz
        .flowtype({
          type: 1,
        })
        .then((res) => {
          this.Filterdata1 = res.data;
        });
    },
    /**
     * 初始化
     */
    onInitData(data) {
      console.log(data, "data===");
      //
      this.cityForm = {
        fleet_id: "", //	T文本	是	装卸队
        amount: "", //	T文本	是	金额
        flow_type: "", //	T文本	是	流水类型: 10-装卸收入，11-用板收入，12-合车收入，13-动帐差异调整收入，14-售后回款，20售后支出，21-动帐差异调整支出，22-打款
        transfer_time: "", //	T文本	是	转账时间
        transfer_img: "", //	T文本	是	转账凭证
        remark: "", //	T文本	是	备注
      };
      this.getfleetlist();
      this.getflowtype();
      this.dialogVisible = true;

      this.$refs.refCityForm?.clearValidate();
    },
    onHandleSubmit() {
      this.$refs.refCityForm.validate((valid) => {
        if (valid) {
        console.log('进来了')
        this.$api.fz
        .balanceadd(this.cityForm)
        .then((res) => {
             this.$message({
              type: "success",
              message: "添加成功",
            });
          this.$emit('suc',true);this.onHandleClose()
        });
        }
      });
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.transfer_img = [];
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.distance-style {
  width: 80%;
}
</style>
